import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  careers: [],
  selectedCareer: null,
  isLoading: false,
  error: null,
};

const careerSlice = createSlice({
  name: "career",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    careerFail: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ✅ Fetch all careers
    getCareersSuccess: (state, action) => {
      state.careers = action.payload;
      state.isLoading = false;
    },

    // ✅ Fetch single career
    getSingleCareerSuccess: (state, action) => {
      state.selectedCareer = action.payload;
      state.isLoading = false;
    },

    // ✅ Create career
    createCareerSuccess: (state, action) => {
      state.careers.push(action.payload);
      state.isLoading = false;
    },

    // ✅ Update career
    updateCareerSuccess: (state, action) => {
      const idx = state.careers.findIndex((c) => c._id === action.payload._id);
      if (idx >= 0) state.careers[idx] = action.payload;
      if (state.selectedCareer?._id === action.payload._id)
        state.selectedCareer = action.payload;
      state.isLoading = false;
    },

    // ✅ Delete career
    deleteCareerSuccess: (state, action) => {
      state.careers = state.careers.filter((c) => c._id !== action.payload);
      if (state.selectedCareer?._id === action.payload)
        state.selectedCareer = null;
      state.isLoading = false;
    },
  },
});

export const {
  isPending,
  careerFail,
  getCareersSuccess,
  getSingleCareerSuccess,
  createCareerSuccess,
  updateCareerSuccess,
  deleteCareerSuccess,
} = careerSlice.actions;

export default careerSlice.reducer;
